
import React from "react";
import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Heading,
  HStack,
  VStack,
  Text,
  Badge,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";

/************************************  B2B ACCOUNT ENGAGEMENT FUNNEL  ************************************/
export const B2BAccountEngagementFunnel = () => {
  const data = [
    { stage: "Targeted", accounts: 300 },
    { stage: "Contacted", accounts: 180 },
    { stage: "Meeting", accounts: 90 },
    { stage: "Proposal", accounts: 40 },
    { stage: "Closed Won", accounts: 15 },
  ];

  const bg     = useColorModeValue("white", "gray.800");
  const border = useColorModeValue("gray.100", "gray.700");

  return (
    <Box p={6} bg={bg} rounded="xl" border="1px" borderColor={border} shadow="sm">
      <Heading as="h3" size="md" mb={4}>Account Engagement Funnel</Heading>
      <VStack spacing={3} align="stretch">
        {data.map((d, idx) => (
          <HStack key={idx} spacing={4} align="center">
            <Box
              flexGrow={1}
              height="16px"
              bg="teal.500"
              rounded="md"
              style={{ width: `${(d.accounts / data[0].accounts) * 100}%` }}
            />
            <Text w="120px" fontSize="sm">{d.stage}</Text>
            <Text fontWeight="medium">{d.accounts}</Text>
          </HStack>
        ))}
      </VStack>
    </Box>
  );
};
